<script>
    export let toast = undefined;
</script>

<span>
    Non è possibile iscriversi! il circolo non è stato trovato.
</span>
